import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass';
import styled from 'styled-components';

const FormContainer = styled(Box)`
    font-size: 14px !important;
    max-width: 800px;
    width: 100%;
    margin: 0 auto !important;
    border-radius: 8px;
    background: #fff;
`;

const FormContainerInner = styled(Box)`
    padding: 20px 40px;
    border-radius: 8px;

    @media (max-width: 768px) {
        padding: 20px 16px;
    }
`;

/**
 * Wrapper around the public-facing form (screener and panel sign-up).
 *
 * `direction` is the single point at which right-to-left rendering is applied:
 * setting `dir` here flips text direction, alignment and reading order for
 * everything inside via CSS's own direction handling. It is a **prop**, not a
 * hardcoded attribute, because `ParticipantFormPage` renders the same wrapper
 * for the printable admin view, which has no language context and must stay
 * left-to-right.
 *
 * Omitting the prop leaves `dir` unset, so the wrapper inherits the document
 * direction exactly as it did before — the API only sends `direction` when the
 * survey-translation feature is on.
 */
const PublicScreenPageFormWrapper = props => (
    <FormContainer as="main" className="nice-boxshadow-light" dir={props.direction || undefined}>
        <FormContainerInner
            style={{
                background: props.screener_bg ? `url(${props.screener_bg}) no-repeat center bottom` : ''
            }}
        >
            {props.children}
        </FormContainerInner>
    </FormContainer>
);

PublicScreenPageFormWrapper.propTypes = {
    /** Base text direction for the form, as served by the API. */
    direction: PropTypes.oneOf(['ltr', 'rtl']),
    screener_bg: PropTypes.string,
    children: PropTypes.node
};

export default PublicScreenPageFormWrapper;
